module.exports = __webpack_public_path__ + "static/media/nsv.ed31afcb.jpg";